import React from 'react';
import {Box, Stack} from '@mui/material';
import MarginPerLineCard from '@components/statistics/cards/MarginPerLine.card';
import ChargedLinesChart from '@components/statistics/charts/ChargedLines.chart';
import TurnoverAndMarginChart from '@components/statistics/charts/TurnoverAndMargin.chart';
import TurnoverChargesServiceKindChart from '@components/statistics/charts/TurnoverChargesServiceKind.chart';
import ValoTurnoverChargesCard from '@components/statistics/cards/ValoTurnoverCharges.card';
import MostProfitableClientsChart from '@components/statistics/charts/MostProfitableClients.chart';

const FinanceTab = () => {
  return (
    <Stack flex={1} spacing={3}>
      <Stack direction="row" spacing={3} flex={1} sx={{overflow: 'hidden'}}>
        <Box flex={1}>
          <MostProfitableClientsChart/>
        </Box>
      </Stack>
      <Stack direction="row" spacing={3} flex={1}>
        <Box flex={1}>
          <TurnoverAndMarginChart/>
        </Box>
      </Stack>
      <Stack direction="row" spacing={3} flex={1}>
        <Box width="260px">
          <MarginPerLineCard/>
        </Box>
        <Box width="260px">
          <ChargedLinesChart type="SUPPLIER"/>
        </Box>
        <Box width="260px">
          <ChargedLinesChart type="CLIENT"/>
        </Box>
        <Box width="360px">
          <ValoTurnoverChargesCard/>
        </Box>
        <Box flex={1}>
          <TurnoverChargesServiceKindChart/>
        </Box>
      </Stack>
    </Stack>
  );
};

export default FinanceTab;
